/**
 * LoveKnotes Cart Upsell & Truck Progress Enhancements
 */

(function () {
  let swiperInstance = null;

  function initCartDrawerUpsellSwiper() {
    const swiperEl = document.querySelector('.cart-drawer-upsell-swiper');
    if (!swiperEl || typeof Swiper === 'undefined') return;

    // Check if drawer is visible and has width
    const drawerInner = swiperEl.closest('.drawer__inner') || document.querySelector('.drawer__inner');
    if (drawerInner && drawerInner.offsetWidth === 0) {
      return;
    }

    if (swiperEl.swiper) {
      try {
        swiperEl.swiper.update();
        return;
      } catch (e) {
        try {
          swiperEl.swiper.destroy(true, true);
        } catch (err) {}
      }
    }

    try {
      swiperInstance = new Swiper(swiperEl, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 12,
        speed: 350,
        grabCursor: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: '.cart-upsell-next',
          prevEl: '.cart-upsell-prev',
        },
      });
    } catch (err) {
      console.warn('Cart upsell Swiper initialization error:', err);
    }
  }

  function handleVariantChange(event) {
    const select = event.target.closest('.cart-upsell-variant-select');
    if (!select) return;

    const card = select.closest('.cart-upsell-card');
    if (!card) return;

    const selectedOption = select.options[select.selectedIndex];
    const variantId = selectedOption.value;
    const variantPrice = selectedOption.dataset.price;

    const addBtn = card.querySelector('.cart-upsell-add-btn');
    if (addBtn && variantId) {
      addBtn.dataset.variantId = variantId;
    }

    const priceEl = card.querySelector('.cart-upsell-card__price');
    if (priceEl && variantPrice) {
      priceEl.textContent = variantPrice;
    }
  }

  async function handleUpsellAdd(event) {
    const btn = event.target.closest('.cart-upsell-add-btn');
    if (!btn || btn.disabled) return;

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    const label = btn.querySelector('.cart-upsell-add-btn__label');
    const spinner = btn.querySelector('.cart-upsell-add-btn__spinner');

    btn.disabled = true;
    if (label) label.classList.add('hidden');
    if (spinner) spinner.classList.remove('hidden');

    try {
      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          sections: ['cart-drawer', 'cart-icon-bubble'],
        }),
      });

      const responseData = await response.json();

      if (response.status === 200) {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          cartDrawer.classList.remove('is-empty');
          cartDrawer.querySelector('.drawer__inner')?.classList.remove('is-empty');
          cartDrawer.querySelector('cart-drawer-items')?.classList.remove('is-empty');
        }

        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(responseData);
        } else if (responseData.sections) {
          if (responseData.sections['cart-drawer']) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = responseData.sections['cart-drawer'];
            const newInner = tempDiv.querySelector('.drawer__inner') || tempDiv.querySelector('#CartDrawer');
            const currentInner = document.querySelector('.drawer__inner') || document.querySelector('#CartDrawer');
            if (newInner && currentInner) {
              currentInner.innerHTML = newInner.innerHTML;
            }
          }
          if (responseData.sections['cart-icon-bubble']) {
            const iconBubble = document.querySelector('#cart-icon-bubble');
            if (iconBubble) {
              const tempDiv = document.createElement('div');
              tempDiv.innerHTML = responseData.sections['cart-icon-bubble'];
              iconBubble.innerHTML = tempDiv.innerHTML;
            }
          }
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'cart-upsell',
            cartData: responseData,
            variantId: variantId,
          });
        }

        setTimeout(initCartDrawerUpsellSwiper, 150);
      } else {
        console.error('Failed to add upsell item to cart:', responseData.description || responseData.message);
        alert(responseData.description || 'Could not add item to cart.');
      }
    } catch (err) {
      console.error('Error adding upsell item:', err);
    } finally {
      btn.disabled = false;
      if (label) label.classList.remove('hidden');
      if (spinner) spinner.classList.add('hidden');
    }
  }

  // Global event delegation
  document.addEventListener('change', handleVariantChange);
  document.addEventListener('click', handleUpsellAdd);

  // Hook CartDrawer.prototype.open
  if (typeof customElements !== 'undefined') {
    customElements.whenDefined('cart-drawer').then(() => {
      const proto = customElements.get('cart-drawer').prototype;
      if (proto && proto.open) {
        const originalOpen = proto.open;
        proto.open = function (triggeredBy) {
          originalOpen.call(this, triggeredBy);
          setTimeout(initCartDrawerUpsellSwiper, 100);
          setTimeout(initCartDrawerUpsellSwiper, 350);
        };
      }
    });
  }

  // Hook into cart updates
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      setTimeout(initCartDrawerUpsellSwiper, 100);
      setTimeout(initCartDrawerUpsellSwiper, 350);
    });
  }

  // Re-init on cart icon click/open
  document.addEventListener('click', (e) => {
    if (e.target.closest('#cart-icon-bubble') || e.target.closest('header .cart-count-bubble') || e.target.closest('.header__icon--cart')) {
      setTimeout(initCartDrawerUpsellSwiper, 150);
      setTimeout(initCartDrawerUpsellSwiper, 350);
    }
  });

  // Watch for drawer active state changes
  if (typeof MutationObserver !== 'undefined') {
    const drawerEl = document.querySelector('cart-drawer');
    if (drawerEl) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            if (drawerEl.classList.contains('active')) {
              setTimeout(initCartDrawerUpsellSwiper, 100);
              setTimeout(initCartDrawerUpsellSwiper, 300);
            }
          }
        });
      });
      observer.observe(drawerEl, { attributes: true });
    }
  }

  // Close cart drawer when checkout button is clicked (e.g. for GoKwik / third-party checkout modals)
  document.addEventListener('click', (e) => {
    const checkoutBtn = e.target.closest('#CartDrawer-Checkout, .cart__checkout-button, [name="checkout"], .cart__ctas button, [class*="gokwik"], [id*="gokwik"], [data-gokwik], [onclick*="gokwik"]');
    if (checkoutBtn && checkoutBtn.closest('cart-drawer, .cart-drawer')) {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        if (typeof cartDrawer.close === 'function') {
          cartDrawer.close();
        } else {
          cartDrawer.classList.remove('active');
          document.body.classList.remove('overflow-hidden');
        }
      }
    }
  }, true);

  // Also close drawer if GoKwik iframe or modal appears
  if (typeof MutationObserver !== 'undefined') {
    const bodyObserver = new MutationObserver(() => {
      const gokwikModal = document.querySelector('#gokwik-iframe, .gokwik-modal, [id*="gokwik-prompt"], [id*="gokwik-checkout"], iframe[src*="gokwik"], div[class*="gokwik"]');
      if (gokwikModal && gokwikModal.offsetHeight > 0) {
        const cartDrawer = document.querySelector('cart-drawer.active');
        if (cartDrawer && typeof cartDrawer.close === 'function') {
          cartDrawer.close();
        }
      }
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  // DOM ready init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartDrawerUpsellSwiper);
  } else {
    initCartDrawerUpsellSwiper();
  }
})();
